import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react';


interface IButton {
    label: string
    fullWidth?: boolean
    onClick?: () => void
    disabled?: boolean
    startIcon?: React.ReactNode
}

export function ButtonSite(props: IButton) {

    /// Parte para colocar os stats e useEffects
    const [width, setWidth] = useState<number>(0);
    const [IsReady, setIsReady] = useState(false);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

     useEffect(() => {
        setIsReady(true)
      }, [])

    useEffect(() => {
        if (IsReady) {
            setWidth(window.innerWidth);
            window.addEventListener('resize', handleWindowSizeChange);
            return () => {
                window.removeEventListener('resize', handleWindowSizeChange);
            }
        }
    }, [IsReady]);

    const isMobile = width <= 768;

    /// JSX
    return (
        <>
           <Button 
                variant="contained"
                fullWidth={props.fullWidth}
                onClick={props.onClick}
                disabled={props.disabled}
                startIcon={props.startIcon}
                sx={{                
                    borderRadius: 20,
                    width: isMobile || props.fullWidth ? '100%' : 'auto',
                    paddingLeft:4,
                    paddingRight:4,
                    height: 48,
                    backgroundColor: '#F18701',
                    texttransform: 'capitalize',
                    fontSize: '18px',
                }}                
            >
               {props.label}
           </Button>
        </>
    )

}